module.exports = __webpack_public_path__ + "ba440a93a6022bd9ecfc8cf409e7327b.png";